module.exports = __webpack_public_path__ + "static/media/github_original.db0721b1.svg";